<template>
  <div class="application-upload-cv">
    <b-alert show variant="success" v-if="applyResult === 'OK'">
      The application has been submitted. Thank you!
    </b-alert>
    <template v-else>
      <p>Submit an application on behalf of a candidate.</p>
      <b-alert show variant="danger" v-if="applyResult === 'ERR'">
        Sorry an error has occurred, please try again.
      </b-alert>
      <apply-box class="my-2" :jobID="job.id" :userID="user.id" on-behalf @submit="applySubmit"/>
    </template>
  </div>
</template>

<script>
import ApplyBox from '@/components/jobs/apply';
import JobApplicationCreateMutation from '@/graphql/mutations/JobApplicationCreate.gql';
import { mapRoot } from '@/mixins/root';

export default {
  name: 'ApplicationUploadCvModal',
  props: {
    job: {
      type: Object,
    },
  },
  components: {
    ApplyBox,
  },
  data: () => ({
    applyResult: null,
  }),
  computed: {
    ...mapRoot([ 'user', 'company', 'isLoggedIn', 'isRecruiter', 'isSuperAdmin' ]),
  },
  methods: {
    async applySubmit(form) {
      try {
        await this.$apollo.mutate({
          mutation: JobApplicationCreateMutation,
          variables: {
            create: {
              job: { id: this.job.id },
              user: { id: this.user.id },
              ...form,
              source: 'JOB',
            },
          },
        });

        this.applyResult = 'OK';
      } catch (err) {
        this.applyResult = 'ERR';
        this.$log.error(err);
        this.$notifyErr(err);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/modals/application-upload-cv.vue